module.exports = __webpack_public_path__ + "static/inquiry-bg-e4c90750339de9b166f074ddfaf4472d.png";